import React from 'react';
import type { SideCardType } from '../../home/components/accordion-sidenav/types';

type HeaderTitleContextType = {
  siteName: string;
  setSiteName: (v: string) => void;
  headerTitle: string;
  setHeaderTitle: (title: string) => void;
  showSideCard: SideCardType;
  setShowSideCard: ({ primary, secondary }) => void;
  openOrgSettingsModal: () => void;
  headerBackButtonRoute: string;
  setHeaderBackButtonRoute: (string) => void;
};

export const HeaderTitleContext = React.createContext<HeaderTitleContextType>({
  siteName: '',
  setSiteName: () => {},
  headerTitle: '',
  setHeaderTitle: () => {},
  showSideCard: { primary: false, secondary: false },
  setShowSideCard: () => {},
  openOrgSettingsModal: () => {},
  headerBackButtonRoute: '',
  setHeaderBackButtonRoute: () => {},
});
